import React from 'react';
import { Link } from 'react-router-dom';
import { Text } from '../../../components';
import { NewRMCard } from '../NewRMCard';
import { RightOutlined } from '@ant-design/icons';

import './EntitlementStatusCard.scss';

export const EntitlementStatusCard = ({ newMigrationData, isAdmin }) => {
    const { availableEntitlements, totalEntitlements } = newMigrationData || {};

    return (
        <NewRMCard className="entitlement-status-card">
            <header>
                <div className="entitlement-status-card-header header-left">
                    <Text size="large" color="secondary">
                        Entitlement Status
                    </Text>
                    {isAdmin && (
                        <Link to="/projects">
                            <Text color="primaryBlue" bold>
                                Manage
                                <RightOutlined />
                            </Text>
                        </Link>
                    )}
                </div>
            </header>
            <div className="entitlement-status-card-content">
                <Text size="extraLarge" xxlBold color="primaryBlue">
                    {availableEntitlements}/{totalEntitlements}
                </Text>
            </div>
        </NewRMCard>
    );
};
